import { render } from "./MoneyTransferModal.vue?vue&type=template&id=262cb8ce&scoped=true&ts=true"
import script from "./MoneyTransferModal.vue?vue&type=script&lang=ts"
export * from "./MoneyTransferModal.vue?vue&type=script&lang=ts"

import "./MoneyTransferModal.vue?vue&type=style&index=0&id=262cb8ce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-262cb8ce"]])

export default __exports__